import { initialPmListAdditionalFields, isTestAdditionalField } from '../constants/initialPmListAdditionalFields';
import { IPmListFilter } from '../interfaces/IPmListFilter';
import { IPmListFilterExtraField } from '../interfaces/IPmListFilterExtraField';

export function mapFilterAdditionalFields(isUserTest: boolean) {
  return (filter: IPmListFilter): IPmListFilterExtraField[] => {
    let items = initialPmListAdditionalFields;

    if (isUserTest && !initialPmListAdditionalFields.find(i => i.id === isTestAdditionalField.id)) {
      items = [...initialPmListAdditionalFields, isTestAdditionalField];
    }

    return items.map<IPmListFilterExtraField>(field => {
      switch (field.id) {
        case 'supervisionType': {
          return {
            ...field,
            isSelected: Boolean(filter.supervisionType?.value),
          };
        }
        case 'startDateBetween': {
          return {
            ...field,
            isSelected:
              (filter.startDateBetweenStart && filter.startDateBetweenStart.length > 0) ||
              (filter.startDateBetweenEnd && filter.startDateBetweenEnd.length > 0) ||
              false,
          };
        }
        case 'hasObjectionWarning': {
          return {
            ...field,
            isSelected: Boolean(filter.hasObjectionWarning),
          };
        }
        case 'reasons': {
          return {
            ...field,
            isSelected: Boolean(filter.reasons?.length),
          };
        }
        case 'subjectTypes': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectTypes?.length),
          };
        }
        case 'subjectOrgName': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectOrgName),
          };
        }
        case 'subjectOgrn': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectOgrn),
          };
        }
        case 'subjectInn': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectInn),
          };
        }
        case 'subjectKpp': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectKpp),
          };
        }
        case 'subjectOkveds': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectOkveds),
          };
        }
        case 'subjectSnils': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectSnils),
          };
        }
        case 'subjectCountries': {
          return {
            ...field,
            isSelected: Boolean(filter.subjectCountries?.length),
          };
        }
        case 'objectAddress': {
          return {
            ...field,
            isSelected: Boolean(filter.objectAddress),
          };
        }
        case 'objectTypes': {
          return {
            ...field,
            isSelected: Boolean(filter.objectTypes?.length),
          };
        }
        case 'objectKinds': {
          return {
            ...field,
            isSelected: Boolean(filter.objectKinds?.length),
          };
        }
        case 'objectSubKinds': {
          return {
            ...field,
            isSelected: Boolean(filter.objectSubKinds?.length),
          };
        }
        case 'objectRiskCategory': {
          return {
            ...field,
            isSelected: Boolean(filter.objectRiskCategory),
          };
        }
        case 'objectDangerClass': {
          return {
            ...field,
            isSelected: Boolean(filter.objectDangerClass),
          };
        }
        case 'isHasCollaboratingOrganization': {
          return {
            ...field,
            isSelected: Boolean(filter.isHasCollaboratingOrganization),
          };
        }
        case 'inspectorFullName': {
          return {
            ...field,
            isSelected: Boolean(filter.inspectorFullName),
          };
        }
        case 'signed': {
          return {
            ...field,
            isSelected: Boolean(filter.signed),
          };
        }
        case 'statuses': {
          return {
            ...field,
            isSelected: Boolean(filter.statuses?.length),
          };
        }
        case 'pubStatuses': {
          return {
            ...field,
            isSelected: Boolean(filter.pubStatuses?.length),
          };
        }
        case 'erpId': {
          return {
            ...field,
            isSelected: Boolean(filter.erpId),
          };
        }
        case 'deletedInclude': {
          return {
            ...field,
            isSelected: Boolean(filter.deletedInclude),
          };
        }
        case 'deletedOnly': {
          return {
            ...field,
            isSelected: Boolean(filter.deletedOnly),
          };
        }
        case 'isTest': {
          return {
            ...field,
            isSelected: Boolean(filter.isTest),
          };
        }
        default:
          return field;
      }
    });
  };
}
